import  Swal  from 'sweetalert2';
import { Subscription } from 'rxjs/Rx';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { interval } from "rxjs/observable/interval";
import { startWith, switchMap } from "rxjs/operators";
import { Logger } from 'angular2-logger/core';
import { SharedService } from '../../shared/shared.service';
import { UserService } from '../user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastsManager } from 'ng2-toastr';

//  Jquery imports
declare var jquery: any; 
declare var $: any;

@Component({    
  selector: 'app-list-agent',
  templateUrl: './list-agent.component.html',
  styleUrls: ['./list-agent.component.scss'],
  providers: [UserService]
}) 
export class ListAgentComponent implements OnInit {

  public time_alert: any;
  public matriz_prueba = [];

  public agents: any;
  public statesList = [];
  public dropdownSettings = {};
  public selectedItems :string = '';
  private state_report_array :string = '';
  private available_report_array :string = '';
  
  public room_atendidos : any;
  public room_atendiendo : any;
  public room_espera : any;
  public room_atendiendo_anteriores:any;
  public room_espera_anteriores:any;
  public room_asignados : any;
  public room_asignados_anteriores : any; 

  //public load: boolean;

  // Observadores.
  private intervalSub: Subscription;
  private intervalSubByStatus: Subscription;

  constructor(
    public _router: Router,
    private _sharedService: SharedService,
    private userService: UserService,
    private logger: Logger, 
    private spinner: NgxSpinnerService,
    public toastr: ToastsManager
  ) {}



  ngOnInit() {
    this.getData(true);
    this.intervalSub = interval(40000).pipe(
      startWith(20000)).subscribe(i => {
        this.getData(false);
        
    });
  }

  public onFilter() {
    this.cancelInterval();
    this.cancelIntervaleByStatus(); 
    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      status: this.state_report_array,
      available: this.available_report_array,
    };

    this.intervalSubByStatus = interval(20000).pipe( 
      startWith(10000)).subscribe(i => {
        
        this.userService.getListAgentsByStatus(data).subscribe( 
          data => {
            if (data.status) {
              this.room_atendidos = data.data.room_atendidos;
              this.room_atendiendo = data.data.room_atendiendo;
              this.room_atendiendo_anteriores =data.data.room_atendiendo_anteriores;
              this.room_espera = data.data.room_espera;
              this.room_espera_anteriores =data.data.room_espera_anteriores;
              this.room_asignados =data.data.room_asignados;
              this.room_asignados_anteriores=data.data.room_asignados_anteriores
              this.agents = data.data.agents_rooms;

              if (data.data != null && data.data.length == 0) {
                this.toastr.info("No se encontraron registros");
              }
              
            } else {
              this.logger.log("Ocurrió un error al consultar los agentes");
              this.toastr.error("Ocurrió un error al realizar el filtro");
            }
    
            this.spinner.hide();
          }, error => { 
            this.logger.log("Ocurrió un error al consultar los agentes", error);
            this.toastr.error("Ocurrió un error al realizar el filtro");
            this.spinner.hide();
          }
        );
    });
    
  }
  route_dashboard(user_id: number, name_agent: boolean) {
    this._router.navigate(['/#/dashboard/'], {});
    this._sharedService.blockSupervisor(user_id, name_agent);

    // Nuevos Desarrollos:
    let token = {
      auth_token: this._sharedService.getCookie("auth_token")
    };

    this._sharedService.getCurrent(token).subscribe(
      data => {
        let infoToServer = {
          actual_user_id: data.data.id,
          user_id_for_change: user_id
        };

        this.userService.updatePreviousUserId(infoToServer).subscribe(
          data => {
            console.log("Actualizado exitósamente! ");
          }, error => {
            console.log("Ups, Algo ha salido mal en user service!");
          });

      }, error => {
        console.log("Ups, Algo ha salido mal en shared Service !");
      });
  }

  route_monitor() {
    this._router.navigate(['/#/admin/monitor/'], {}); 
  }

  private getData(mostrarSpinner: boolean) {
    
    if (mostrarSpinner) { 
      this.spinner.show();
    }
    let data = {
      auth_token: this._sharedService.getCookie("auth_token"),
    };

    this.userService.getListAgents(data).subscribe(  
      data => {
        this.room_atendidos = data.data.room_atendidos;
        this.room_atendiendo = data.data.room_atendiendo;
        this.room_atendiendo_anteriores =data.data.room_atendiendo_anteriores;
        this.room_espera = data.data.room_espera;
        this.room_espera_anteriores =data.data.room_espera_anteriores;
        this.room_asignados =data.data.room_asignados;
        this.room_asignados_anteriores=data.data.room_asignados_anteriores
        this.agents = data.data.agents_rooms;
        this.spinner.hide();

      },
      error => {
        this.logger.log("Ocurrió un error al consultar los agentes", error);
        this.spinner.hide();
      }
    );
  }


  public cancelInterval() {
    if (this.intervalSub) {
      this.intervalSub.unsubscribe();
    }
  }

  public cancelIntervaleByStatus() { 
    if (this.intervalSubByStatus) {
      this.intervalSubByStatus.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.cancelInterval();
    this.cancelIntervaleByStatus();
  }
  
  

  shutDownAgent(dataFromMonitor: any) {
    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      status: this.state_report_array,
      user_id: dataFromMonitor.id
    };
    Swal({
      title: "Perfecto",
      text: 'La sesión de ' + dataFromMonitor.firstname + ' ' + dataFromMonitor.lastname + ' se cerrará en máximo dos minutos!',
      type: 'success',
      timer: 5000,
      showConfirmButton: false
    }).then(() => {
      this._sharedService.setAgentToLogout(data).subscribe(
        data => {
        //console.log("Esto es lo que me retorna el servidor:_ ", data);
        }, error => {
          console.log(error);
          Swal({
            title: "Ups!",
            text: 'Ocurrió un error por favor inténtalo de nuevo.',
            type: 'error',
            timer: 5000,
            showConfirmButton: false
          });
      });
    }), error => {
      Swal({
        title: "Ups!",
        text: 'Ocurrió un error por favor inténtalo de nuevo.',
        type: 'error',
        timer: 5000,
        showConfirmButton: false
      });
    }
  }
  

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/list-agent/list-agent.component.ts